import { useUserInfor } from "../../../Context/User";

import "./styles.css";

import Modulos from "../../Modulos";

import { useAtedimento } from "../../../Context/Atendimento";
import { ACESSOS } from "../../../Routes/Acessos";
import {
    LoginAgenteController,
    LogoutAgenteController,
} from "../../../Controllers/Geral/Telefonia/TelefoniaController";
import { useState } from "react";
import { useStorage } from "../../../hooks/useStorage";
import { IComponentModal } from "../../Modais/IModalComponent";
import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlterarSenhaModal from "./ModalAlterarSenha";
import ModalComponent from "../../Modais";
import { useHistory } from "react-router-dom";

export default function QuickUser() {
    const { UserInfor, OrgInfor, Config } = useUserInfor();
    const logo = OrgInfor.URL_LOGO
        ? `https://crm.capys.com.br${OrgInfor.URL_LOGO.replace("~", "")}`
        : "";

    const loginRoute = useStorage<boolean>("DEFAULT_LOGIN_ONLY_SSO")[0]
        ? "/sso"
        : "/login";

    const history = useHistory();

    const {
        modoAtendimento,
        HELP_DESK,
        selecionarFila,
        finalizarAtendimentoEmFila,
    } = useAtedimento();
    const modulos = useUserInfor().UserInfor.MODULOS;
    const [FL_BUTTON, setFL_BUTTON] = useState(true);

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    return (
        <div
            id="kt_quick_user"
            className="offcanvas offcanvas-right p-10 scrollPerso"
        >
            <main>
                <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
                    <h3 className="font-weight-bold m-0">
                        Perfil
                        {/* <small className="text-muted font-size-sm ml-2">
                            12 Compromissos
                        </small> */}
                    </h3>
                    <a
                        href="#/"
                        className="btn btn-xs btn-icon btn-light btn-hover-primary"
                        id="kt_quick_user_close"
                    >
                        <i className="ki ki-close icon-xs text-muted"></i>
                    </a>
                </div>
                <div
                    className="offcanvas-content pr-5 mr-n5"
                    style={{ overflow: "hidden" }}
                >
                    <div className="d-flex align-items-center mt-5 mb-7">
                        <div className="symbol symbol-100 mr-5">
                            <img
                                src={logo}
                                alt={OrgInfor.DS_ORGANIZACAO + " logo"}
                                className="orgImg"
                            />
                            <i className="symbol-badge bg-success"></i>
                        </div>
                        <div className="d-flex flex-column">
                            <a
                                href="#/"
                                className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
                            >
                                {UserInfor.DS_NOME}
                            </a>
                            <div className="text-muted mt-1">
                                Application Developer
                            </div>
                            <div className="navi mt-2">
                                <a href="#/" className="navi-item">
                                    <span className="navi-link p-0 pb-2">
                                        <span className="navi-icon mr-1">
                                            <span className="svg-icon svg-icon-lg svg-icon-primary">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24px"
                                                    height="24px"
                                                    viewBox="0 0 24 24"
                                                    version="1.1"
                                                >
                                                    <g
                                                        stroke="none"
                                                        strokeWidth="1"
                                                        fill="none"
                                                        fillRule="evenodd"
                                                    >
                                                        <rect
                                                            x="0"
                                                            y="0"
                                                            width="24"
                                                            height="24"
                                                        />
                                                        <path
                                                            d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                                                            fill="#000000"
                                                        />
                                                        <circle
                                                            fill="#000000"
                                                            opacity="0.3"
                                                            cx="19.5"
                                                            cy="17.5"
                                                            r="2.5"
                                                        />
                                                    </g>
                                                </svg>
                                            </span>
                                        </span>
                                        <span className="navi-text text-muted text-hover-primary">
                                            {UserInfor.DS_EMAIL}
                                        </span>
                                    </span>
                                </a>
                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-primary d-flex align-items-center justify-content-center font-weight-bolder g-1 mr-2"
                                        onClick={() =>
                                            history.push(
                                                ACESSOS.GERAL.TELAS
                                                    .INFORMACOES_ORGANIZACAO
                                                    .DS_PATH
                                            )
                                        }
                                    >
                                        Perfil
                                        <span>
                                            <FontAwesomeIcon
                                                icon={faInfoCircle}
                                            />
                                        </span>
                                    </button>
                                    <a
                                        href={loginRoute}
                                        className="btn btn-sm btn-light-primary font-weight-bolder py-3 px-5"
                                        onClick={() => {
                                            localStorage.removeItem("@token");

                                            const encodedData = btoa(
                                                JSON.stringify({
                                                    ID_ORGANIZACAO:
                                                        OrgInfor.ID_ORGANIZACAO,
                                                    ID_USUARIO:
                                                        UserInfor.ID_USUARIO,
                                                    ultimaUrl:
                                                        window.location.pathname.split(
                                                            "/"
                                                        )[1],
                                                    FL_ULTIMO_MODULO:
                                                        Config.FL_ULTIMO_MODULO,
                                                })
                                            );

                                            localStorage.setItem(
                                                "userData",
                                                encodedData
                                            );
                                        }}
                                    >
                                        Sair
                                    </a>
                                </div>

                                {Config?.ConfigUraIntegracaoTelefoniaDTO
                                    ?.FL_INTEGRACAO_URA_CRM &&
                                Config?.ConfigUraIntegracaoTelefoniaDTO
                                    ?.ID_INTEGRADOR_URA &&
                                UserInfor?.ID_RAMAL_DISCADOR &&
                                UserInfor?.NR_AGENTE_DISCADOR ? (
                                    FL_BUTTON ? (
                                        <span
                                            className="btn btn-sm btn-light-danger font-weight-bolder py-2 px-5 "
                                            onClick={() => {
                                                LogoutAgenteController()
                                                    .then(() => {
                                                        setFL_BUTTON(false);
                                                    })
                                                    .catch(() => {
                                                        setFL_BUTTON(false);
                                                    });
                                            }}
                                        >
                                            Sair Telefonia
                                        </span>
                                    ) : (
                                        <span
                                            className="btn btn-sm btn-light-success font-weight-bolder py-2 px-5 "
                                            onClick={() => {
                                                LoginAgenteController()
                                                    .then(() => {
                                                        setFL_BUTTON(true);
                                                    })
                                                    .catch(() => {
                                                        setFL_BUTTON(true);
                                                    });
                                            }}
                                        >
                                            Entrar Telefonia
                                        </span>
                                    )
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="separator separator-dashed mt-8 mb-5"></div>

                    <div className="navi navi-spacer-x-0 p-0">
                        {
                            <div className="flex-sm-row-fluid d-flex flex-column">
                                <h3 className="card-title align-items-center flex-row mb-2">
                                    Alterar Senha
                                </h3>
                                <div className="RowCol1 align-items-center d-flex flex-row mb-2">
                                    {
                                        <button
                                            className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap g-2"
                                            onClick={() => {
                                                setShow(true);
                                                setModal({
                                                    headerComponent:
                                                        "Alterar Senha",
                                                    IconHeader: faEdit,
                                                    Component: () => (
                                                        <AlterarSenhaModal
                                                            setShow={setShow}
                                                        />
                                                    ),
                                                });
                                            }}
                                        >
                                            Alterar Senha
                                            <span>
                                                <FontAwesomeIcon
                                                    icon={faEdit}
                                                />
                                            </span>
                                        </button>
                                    }
                                    <ModalComponent
                                        setShow={setShow}
                                        show={show}
                                        ModalComponent={modal}
                                    />
                                </div>
                            </div>
                        }
                        {modulos &&
                            modulos.find(
                                (modulo) =>
                                    modulo.ID_MODULO ===
                                    ACESSOS.COBRANCA.ID_MODULO
                            ) && (
                                <div className="flex-sm-row-fluid d-flex flex-column">
                                    <h3 className="card-title align-items-center flex-row mb-2">
                                        Atendimento
                                    </h3>
                                    <div className="RowCol1 align-items-center d-flex flex-row mb-2">
                                        {modoAtendimento ? (
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    if (
                                                        modoAtendimento ===
                                                        "FILA"
                                                    ) {
                                                        finalizarAtendimentoEmFila();
                                                    } else if (
                                                        modoAtendimento ===
                                                        "HELP DESK"
                                                    )
                                                        HELP_DESK.finalizarAtendimentoHelpDesk();
                                                }}
                                            >
                                                Sair do modo de atendimento
                                            </button>
                                        ) : (
                                            <button
                                                className="btn atendimento-btn"
                                                onClick={() => {
                                                    selecionarFila();
                                                }}
                                            >
                                                Entrar em modo de atendimento
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}

                        <div className="flex-sm-row-fluid d-flex flex-column">
                            {UserInfor.MODULOS &&
                            UserInfor.MODULOS.length > 1 ? (
                                <h3 className="card-title align-items-center flex-row">
                                    Módulos Vinculados
                                </h3>
                            ) : (
                                <h3 className="card-title align-items-center flex-row">
                                    Módulo Vinculado
                                </h3>
                            )}
                            <div className="RowCol1 align-items-center d-flex flex-row flex-wrap">
                                {UserInfor.MODULOS &&
                                UserInfor.MODULOS.length >= 1 ? (
                                    UserInfor.MODULOS.map((modulos) => {
                                        const responseJsx = Modulos(
                                            modulos.ID_MODULO
                                        );
                                        return (
                                            <div
                                                className="modulos d-flex ml-1 flex-wrap"
                                                key={modulos.ID_MODULO}
                                            >
                                                {responseJsx}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <span className="navi-text text-muted text-hover-primary">
                                        Não existe módulo vinculado
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="flex-sm-row-fluid d-flex flex-column mt-7">
                            <div className="flex-sm-row-fluid d-flex flex-column">
                                {UserInfor.GRUPOS &&
                                UserInfor.GRUPOS.length > 1 ? (
                                    <h3 className="card-title align-items-center flex-row">
                                        Grupos vinculados
                                    </h3>
                                ) : (
                                    <h3 className="card-title align-items-center flex-row">
                                        Grupo vinculado
                                    </h3>
                                )}
                                <div className="RowCol1 align-items-center d-flex flex-wrap flex-row">
                                    {UserInfor.GRUPOS &&
                                    UserInfor.GRUPOS.length >= 1 ? (
                                        UserInfor.GRUPOS.map((grupos) => {
                                            return (
                                                <span
                                                    className="label label-lg font-weight-bold  label-light-info label-inline mr-2 mt-2"
                                                    key={grupos.ID_GRUPO}
                                                >
                                                    {grupos.DS_GRUPO}
                                                </span>
                                            );
                                        })
                                    ) : (
                                        <span className="navi-text text-muted text-hover-primary">
                                            Não existe grupo vinculado
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer">
                    <hr />
                    <div className="flex-sm-row-fluid d-flex flex-column mt-7 orgData">
                        <div className="flex-sm-row-fluid d-flex flex-column">
                            <h5 className="m-0">{OrgInfor.DS_ORGANIZACAO}</h5>
                            <div>
                                {OrgInfor.DS_RAZAO_SOCIAL !==
                                    OrgInfor.DS_ORGANIZACAO &&
                                    `${OrgInfor.DS_RAZAO_SOCIAL}`}
                                {OrgInfor.DS_NOME_FANTASIA &&
                                    OrgInfor.DS_NOME_FANTASIA !==
                                        OrgInfor.DS_RAZAO_SOCIAL &&
                                    `/ ${OrgInfor.DS_NOME_FANTASIA}`}
                            </div>
                            <div>
                                {`${OrgInfor.DS_LOGRADOURO}, n${OrgInfor.NR_ENDERECO} - ${OrgInfor.DS_BAIRRO}`}
                            </div>
                            <div>CNPJ: {OrgInfor.NR_CNPJ}</div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
